import moment from "moment";

/**
 * Defines the available date format types
 * These are common moment.js format patterns
 */
export type DateFormatType =
  | "YYYY-MM-DD" // 2025-05-02
  | "YYYY-MM" // 2025-05
  | "DD-MM-YYYY" // 02-05-2025
  | "MM-DD-YYYY" // 05-02-2025
  | "YYYY/MM/DD" // 2025/05/02
  | "MM/DD/YYYY" // 05/02/2025
  | "DD/MM/YYYY" // 02/05/2025
  | "MMMM D, YYYY" // May 2, 2025
  | "D MMMM YYYY" // 2 May 2025
  | "YYYY" // 2025
  | "MM" // 05
  | "DD" // 02
  | "YYYYMMDD" // 20250502
  | "YYYY-MM-DD HH:mm:ss" // 2025-05-02 14:30:00
  | "YYYY-MM-DDTHH:mm:ssZ"; // 2025-05-02T14:30:00+00:00 (ISO format)

export function generateGreetings(): string {
  const hour = moment().hour();

  if (hour > 16) {
    return "Good Evening";
  }

  if (hour > 11) {
    return "Good Afternoon";
  }

  return "Good Morning";
}

export function appTimeZoneHandler(
  dateToFormat: Date | string,
  timeZoneUtcAddHour: string,
  outputDateFormat: string
): string {
  return moment(dateToFormat)
    .utcOffset(timeZoneUtcAddHour)
    .format(outputDateFormat);
}

export function wait(timeout: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}

export const getDaysBetweenDates = function (
  startDate: Date | string,
  endDate: Date | string,
  dateFormat: string
) {
  const now = moment(startDate).clone(),
    dates = [];

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format(dateFormat));
    now.add(1, "days");
  }
  return dates;
};

export const getAllHoursInRange = function (
  startTime: Date | string,
  endTime: Date | string,
  timeFormat: string
) {
  const now = moment(startTime, timeFormat).clone(),
    hoursAndMins = [];

  // console.log("getAllHoursInRange => now: ", now.format(timeFormat));

  const endTimeFull = moment(endTime, timeFormat);

  // console.log(
  //   "getAllHoursInRange => endTimeFull: ",
  //   endTimeFull.format(timeFormat)
  // );

  // console.log(
  //   "getAllHoursInRange => now.isSameOrBefore(endTimeFull): ",
  //   now.isSameOrBefore(endTimeFull)
  // );

  while (now < endTimeFull) {
    hoursAndMins.push(now.format(timeFormat));
    now.add(1, "hours");
  }

  return hoursAndMins;
};

export const getAllMinutesInRange = function (
  startTime: Date | string,
  endTime: Date | string,
  minuteAmount: number,
  timeFormat: string
) {
  const now = moment(startTime, timeFormat).clone(),
    hoursAndMins = [];

  const endTimeFull = moment(endTime, timeFormat);

  while (now < endTimeFull) {
    hoursAndMins.push(now.format(timeFormat));
    now.add(minuteAmount, "minutes");
  }

  return hoursAndMins;
};

/**
 * Returns the current date in the specified format
 * @param format - The desired format (defaults to 'YYYY-MM-DD')
 * @returns {string} Formatted current date
 */
export function getCurrentDateFormatted(
  format: DateFormatType = "YYYY-MM-DD"
): string {
  return moment().format(format);
}

/**
 * Returns a specific date in the specified format
 * @param date - Date to format (defaults to current date)
 * @param format - The desired format (defaults to 'YYYY-MM-DD')
 * @returns {string} Formatted date
 */
export function formatDate(
  date: Date | string | number = new Date(),
  format: DateFormatType = "YYYY-MM-DD"
): string {
  return moment(date).format(format);
}
